import { Component, OnInit } from '@angular/core';
import { trigger, style, transition, animate, query, group } from '@angular/animations';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth/auth.service';
import { BackgroundService } from '../shared/services/background.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { environment } from '../../environments/environment';
import { SignalrService } from '../shared/services/signalr.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.css'],
  animations: [
    trigger('tall', [
      transition(':enter', [style({ bottom: '30vh' }), animate('.2s ease-in-out', style({ bottom: 0 }))]),
      transition(':leave', [style({ bottom: 0 }), animate('.2s ease-in-out', style({ bottom: '100%' }))])
    ]),

    trigger('fadeIn', [
      transition(':enter', [style({ opacity: 0 }), animate('.2s ease-in-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('.2s ease-in-out', style({ opacity: 0 }))])
    ]),

    trigger('slideUp', [
      transition(':enter', [
        style({ height: 0, marginBottom: 0 }),
        query('main', style({ transform: 'translate(0, -10%)', opacity: 0 })),

        group([
          animate('.2s ease-in-out', style({ height: '*', marginBottom: '*' })),
          query('main', animate('.2s ease-in-out', style({ transform: 'translate(0, 0)', opacity: 1 })))
        ])
      ]),
      transition(':leave', [
        style({ height: '*', marginBottom: '*' }),
        query('main', style({ transform: 'translate(0, 0)', opacity: 1 })),

        group([
          query('main', animate('.2s ease-in-out', style({ transform: 'translate(0, -10%)', opacity: 0 }))),
          animate('.2s ease-in-out', style({ height: 1, marginBottom: 0 }))
        ])
      ])
    ])
  ]
})
export class BackgroundComponent {
  public baseTokenUrl = environment.production
    ? 'https://telegram.me/IDF_Spokesperson_Bot?start='
    : 'https://telegram.me/IDF_Spokesperson_Staging_Bot?start=';

  constructor(
    public router: Router,
    public auth: AuthService,
    public service: BackgroundService,
    public loader: LoadingBarService,
    public signalR: SignalrService
  ) {}

  public hideTelegramButton() {
    if (this.auth.userData) this.auth.userData.telegramToken = null;
  }

  public get nowOnSignin() {
    return this.router.url.startsWith('/signin') || this.router.url.startsWith('signin');
  }
  public get nowOnRegister() {
    return this.router.url.startsWith('/register') || this.router.url.startsWith('register');
  }
}
